import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import DocumentCopyEditSection from "documentV1/copy/DocumentCopyEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import { routes } from "utilities/routing/generatedRoutes";

export const CopyInvoiceApp = () => {
  const viewModel = useLoaderData<server.viewmodel.InvoiceV1CopyFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <SectionPanel.Section>
        <DocumentCopyEditSection
          products={viewModel.products}
          document={viewModel.invoice}
          artistRiders={viewModel.artistRiders}
        />
      </SectionPanel.Section>
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[
          { text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl },
          { text: RESX.Buttons.DetailView, visible: true, href: routes.invoiceV1_Detail(viewModel.invoice.invoiceId).absolute },
        ]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>;
};

export default CopyInvoiceApp;

